import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { ListCardGroup } from 'components/list-card-group';

import { ModifierListItem } from './modifier-list-item';
import { IModifierMultiplier, IModifierTypeUIProps } from './types';
import { logProductModifierCustomization } from './utils';

export const ModifierSingleChoice: React.FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const { formatMessage } = useIntl();

  const handleListItemPress = useCallback(
    (multiplier: IModifierMultiplier) => {
      onSelectionsChange({ [multiplier.id]: 1 });
      logProductModifierCustomization(multiplier.name, modifier.name, multiplier.id);
    },
    [onSelectionsChange, modifier]
  );

  return (
    <ListCardGroup
      isFullContainer
      header={formatMessage(
        { id: 'chooseItemAmount' },
        { amount: modifier.quantity.max, itemName: modifier.name }
      )}
      items={modifier.multipliers}
      renderItem={({ item: multiplier }: { item: IModifierMultiplier }) => (
        <ModifierListItem
          key={multiplier.id}
          isSelected={!!selections[multiplier.id]}
          onListItemPress={handleListItemPress}
          itemValue={multiplier}
          content={multiplier}
        />
      )}
    />
  );
};
